import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CgCPlusPlus } from 'react-icons/cg';
import {
    DiJavascript1,
    DiReact,
    DiNodejs,
    DiMongodb,
    DiPython,
    DiHtml5,
    DiCss3,
} from 'react-icons/di';
import {
    SiFlask,
    SiRedux,
    SiSocketDotIo,
    SiPostgresql,
    SiJinja,
} from 'react-icons/si';
import { SiFirebase } from 'react-icons/si';

function Techstack() {
    return (
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
            <Col xs={4} md={2} className='tech-icons'>
                <CgCPlusPlus />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <DiJavascript1 />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <DiPython />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <DiHtml5 />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <DiCss3 />
            </Col>

            <Col xs={4} md={2} className='tech-icons'>
                <DiNodejs />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <DiReact />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <DiMongodb />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <SiRedux />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <SiSocketDotIo />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <SiFirebase />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <SiFlask />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <SiPostgresql />
            </Col>
            <Col xs={4} md={2} className='tech-icons'>
                <SiJinja />
            </Col>

            <Col xs={4} md={2} className='tech-icons'>
                <span
                    className='iconify'
                    data-icon='simple-icons:scikitlearn'
                ></span>
            </Col>
        </Row>
    );
}

export default Techstack;
